export default {"src":"https://fishbrain.com/_next/static/media/kansas.04dd7bf9.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};